import { render, staticRenderFns } from "./collegeBi.vue?vue&type=template&id=ebe4333a&scoped=true&"
import script from "./collegeBi.vue?vue&type=script&lang=js&"
export * from "./collegeBi.vue?vue&type=script&lang=js&"
import style0 from "./collegeBi.vue?vue&type=style&index=0&id=ebe4333a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe4333a",
  null
  
)

export default component.exports